<template>
  <section id="hero">
    <base-jumbotron
      :src="require('@/assets/Richmond-Blur-Small.jpg')"
      color="grey darken-4"
      dark
      min-height="300px"
      height="40vh"

    >
      <v-row
        align="center"
        class="pb-12"
      >
        <v-col
          cols="12"
          md="8"
        >
          <div>
            <base-title>
                {{routeName}}
            </base-title>
            <v-divider class="mb-3"/>
          </div>
        </v-col>
      </v-row>
    </base-jumbotron>
  </section>
</template>

<script>
export default {
    name: 'HomeHero',
    computed: {
        routeName() {
            return this.$route.name.replace(/([a-z])([A-Z])/g, '$1 $2');
        }
    },

}
</script>
